var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3635_683)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 36.4495,
    r: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9997 39.116C36.4397 39.116 29.333 40.8894 29.333 44.4494V47.116H50.6663V44.4494C50.6663 40.8894 43.5597 39.116 39.9997 39.116ZM27.9997 33.7827V29.7827H25.333V33.7827H21.333V36.4494H25.333V40.4494H27.9997V36.4494H31.9997V33.7827M39.9997 36.4494C41.4142 36.4494 42.7707 35.8875 43.7709 34.8873C44.7711 33.8871 45.333 32.5305 45.333 31.116C45.333 29.7016 44.7711 28.345 43.7709 27.3448C42.7707 26.3446 41.4142 25.7827 39.9997 25.7827C38.5852 25.7827 37.2286 26.3446 36.2284 27.3448C35.2282 28.345 34.6663 29.7016 34.6663 31.116C34.6663 32.5305 35.2282 33.8871 36.2284 34.8873C37.2286 35.8875 38.5852 36.4494 39.9997 36.4494Z",
    fill: "#ED8842"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3635_683",
    x: 0.8,
    y: 0.249463,
    width: 72.4,
    height: 72.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.269963 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3635_683"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3635_683",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.153451cbdb0f63d7ffbb481a4d45ce4e.svg";
export { ForwardRef as ReactComponent };